export const GRAPH_ACTION_TYPES = {
	HIGHLIGHT_SELECTED_POINT: 'highlight',
	DOWNPLAY_STALE_POINT: 'downplay',
	SHOW_TOOL_TIP: 'showTip',
	HIDE_TIP: 'hideTip',
} as const;

export const GRAPH_EVENT_TYPES = {
	CLICK: 'click',
	MOUSE_OVER: 'mouseover',
	MOUSE_OUT: 'mouseout',
} as const;
